export const columns = [
    {
        title: "Product",
        links: [
            { label: "CBN Regulatory Sandbox", href: "/products/beyond-sandbox/apis" },
            { label: "NRS Tax Compliance Gateway", href: "/products/tax-collection-gateway/api-reference" },
            { label: "Third Party APIs", href: "/products/third-party-apis" },
        ],
    },
    {
        title: "Company",
        links: [
            { label: "About", href: "https://emtech.com/about-us" },
            { label: "Case Studies", href: "https://emtech.com/resources/case-studies" },
        ],
    },
    {
        title: "Resources",
        links: [
            { label: "System Status", href: "https://status.emtech.com" },
            { label: "Support", href: "/support" },
            { label: "Contact Us", href: "https://emtech.com/contact-us" },
        ],
    },
    {
        title: "Legal",
        links: [
            { label: "Terms", href: "https://emtech.com/terms-&-conditions" },
        ],
    },
]